import createVueComponent from '../createVueComponent';

const SearchCheck = createVueComponent('SearchCheckIcon', [
  ['path', { d: 'm8 11 2 2 4-4', key: '1sed1v' }],
  ['circle', { cx: '11', cy: '11', r: '8', key: '4ej97u' }],
  ['path', { d: 'm21 21-4.3-4.3', key: '1qie3q' }],
]);

export default SearchCheck;
